import {
  IEmailCustomization,
  EventEmailCustomizationMediaType,
} from "modules/emailCustomization/types";
import { generateEmailHeader, generateMediaHtml } from "./common";
import { defaultValues } from "./defaults";

export const generateInviteEmailHtml = (
  customization?: IEmailCustomization,
): string => {
  const headerImageURL =
    customization?.headerImageURL || defaultValues.imageUrl;
  const textBlock1 =
    customization?.textBlock1 || defaultValues.inviteTextBlock1;
  const ctaButtonText =
    customization?.ctaButtonText || defaultValues.eventCTAButtonText;
  const textBlock2 =
    customization?.textBlock2 || defaultValues.inviteTextBlock2;
  const senderImageURL =
    customization?.senderImageURL || defaultValues.senderImageUrl;
  const isImageMedia =
    customization?.mediaType === EventEmailCustomizationMediaType.IMAGE;
  const mediaUrl = customization?.mediaURL || "";
  const mediaExtraImageURL = customization?.mediaExtraImageURL || "";
  const { eventUrl, eventName, fromName, videoUrl, videoThumbnailUrl } =
    defaultValues;

  const mediaHtml = generateMediaHtml(
    isImageMedia,
    mediaUrl,
    mediaExtraImageURL,
    videoUrl,
    videoThumbnailUrl,
  );

  return `${generateEmailHeader()}
    <tr>
      <td align="center" style="padding: 0;">
        <img src="${headerImageURL}" alt="${eventName}" style="width: 100%; height: 150px; object-fit: cover;">
      </td>
    </tr>
    <tr>
      <td style="padding: 20px 0 10px;">
        <p style="margin: 0 0 20px 0; font-size: 16px;">${textBlock1}</p>
      </td>
    </tr>
    <tr>
      <td align="center" style="padding-bottom: 10px;">
        <a href="${eventUrl}" style="display: inline-block; padding: 12px 24px; background-color: #2563EB; color: #ffffff; text-decoration: none; border-radius: 4px; font-weight: bold; font-size:18px">${ctaButtonText}</a>
      </td>
    </tr>
    <tr>
      <td style="padding: 10px 0;">
        <p style="margin: 0; font-size: 12px; color: #666666;">If you cannot access the button above, click this link: <a href="${eventUrl}" style="color: #2563EB; text-decoration: underline;">${eventUrl}</a></p>
      </td>
    </tr>
    <tr>
      <td style="padding: 20px 0;">
        <p style="margin: 0 0 20px 0; font-size: 16px;">${textBlock2}</p>
        <div style="text-align: center;">${mediaHtml}</div>
      </td>
    </tr>
    <tr>
      <td style="padding: 20px 0;">
        <p style="margin: 0 0 5px 0;">I'm excited to have you join me!</p>
        <p style="margin: 0;">${fromName}</p>
      </td>
    </tr>
    <tr>
      <td align="left">
        <img src="${senderImageURL}" alt="Sender Logo" style="width: 150px; height: 35px;">
      </td>
    </tr>
  </table>
</body>
</html>`;
};
